module.exports = __webpack_public_path__ + "static/media/visual-grammar-img-002.49d80a0c.jpg";